import {createContext} from "preact";
import {useState} from "preact/hooks";

export const GlobalContext = createContext({});

export const withGlobals = (Component) => {
  return function NavigationComponent(props) {
    return <GlobalContext.Consumer>
      {contexts => <Component {...props} globals={contexts} />}
    </GlobalContext.Consumer>;
  }
}

export const GlobalContextProvider = ({ children, apiKey, user, options }) => {
  const [_user, setUser] = useState(user);
  const [organization, setOrganization] = useState(null);

  return <GlobalContext.Provider value={{
    apiKey,
    user: _user,
    options,
    organization,
    setOrganization,
    setUser
  }}>{children}</GlobalContext.Provider>;
}



// WEBPACK FOOTER //
// ./contexts/GlobalContext.js